module.exports = __webpack_public_path__ + "static/what-we-do-illustration-749ab264762705f479843c8fd4e2e325.svg";